import React, { Component } from 'react'
import { BrowserRouter, Route, Redirect, Switch } from 'react-router-dom'
import ShowData from '../ShowData'
import Attendees from '../Users'
import ContactSupportForm from '../ContactSupportForm'
import CustomPage from '../CustomPage'
import Events from '../Events'
import Evaluations from '../Evaluations'
import EventEvaluation from '../Evaluations/EventEvaluation.js'
import Homepage from '../Homepage'
import Leaderboard from '../Leaderboard'
import Notes from '../Notes'
import Messages from '../Messages'

import Message from '../Messages/show.js'
import Navigation from './Navigation.js'
import ResetPasswordForm from '../ResetPasswordForm'
import Sessions from '../Sessions'
import Scanner from '../Scanner'
import SettingsAndSupport from '../SettingsAndSupport'
import SessionEvaluation from '../Evaluations/SessionEvaluation.js'
import OneOnOneSessionEvaluation from '../Evaluations/OneOnOneSessionEvaluation.js'
import Sponsors from '../Sponsors'
import Sponsor from '../Sponsors/show.js'
import Session from '../Sessions/show.js'
import UserProfile from '../Users/show.js'
import MyProfile from '../Users/MyProfile.js'
import MyProfileEdit from '../Users/MyProfileEdit.js'
import MyProfilePhoto from '../Users/MyProfilePhoto'
import './layout.css'
import $ from 'jquery'
import getLabel from '../../utilities/label.js'

class Layout extends Component {
  constructor(props) {
    super(props)
    this.setActiveTab = this.setActiveTab.bind(this)
    const currentEventUser = this.currentEventUser()
    const currentEvent = this.currentEvent()
    this.state = {
      activeTab: null,
      currentEventUser: currentEventUser,
      currentEvent: currentEvent,
    }
    this.updateResource = this.updateResource.bind(this)
    this.getLabelizedNavTitle = this.getLabelizedNavTitle.bind(this)
  }

  toggleDebug() {
    $('.debug-json').toggle()
  }

  updateResource({ key, callback }) {
    this.props.getResource({
      key: key,
      update: true,
      callback: callback
    })
  }

  goBack() {
    window.history.back()
  }

  getLabelizedNavTitle(key) {
    const appNavs = this.props.currentUser.app_navigations
    let currentNav = appNavs.find( (appNav) => {
      return appNav.key === key
    })
    return currentNav ? currentNav.name : key
  }

  contactSupportBlock() {
    const homepageBlocks = this.props.homepage.homepage.homepage_blocks
    const homepageBlock = homepageBlocks.find((block) => {
      return block.type_key === 'contact_form'
    })
    return homepageBlock ? homepageBlock : {}
  }

  currentEventUser() {
    const eventUsers = this.props.users.event_users
    const currentUser = this.props.currentUser
    return eventUsers.find((user) => {
      return user.user_id === currentUser.user_id
    })
  }

  currentEvent() {
    const currentUser = this.props.currentUser
    const events = this.props.events.events
    return events.find((event) => {
      return event.id === currentUser.current_event_id
    })
  }

  setActiveTab(item = 'homepage', overwrite = true) {
    // only set the activeTab if this update is meant to
    // overwrite the current activeTab
    // or if there is no current activeTab
    if (overwrite || !this.state.activeTab) {
      this.setState({ activeTab: item })
    }
  }

  render() {
    const { currentEventUser } = this.state
    const backButton = '<i class=\'fa fa-arrow-left\'></i> ' + getLabel('back_button')
    // Commenting out debug for now.
    // TODO: Add logic so this can appear in all environments except production.
    const debug = '' // (<a className='float-right' onClick={ this.toggleDebug }><i className='fa fa-bug'></i></a>)
    return (
      <BrowserRouter>
        <div className="container">
          <Navigation
            activeTab = { this.state.activeTab }
            currentUser={ this.props.currentUser }
            logout={ this.props.logout }
            messages={ this.props.messages }
            sessions={ this.props.sessions }
            flashMessage={ this.props.flashMessage }
            users={ this.props.users }/>
          <div>
            <Switch>
              <Route
                path='/attendees'
                render={ (props) =>
                  <Attendees {...props}
                    users={ this.props.users }
                    getResource={ this.props.getResource }
                    setActiveTab= { this.setActiveTab }
                  />
                }
              />

              <Route
                path='/user/:id'
                render={ (props) =>
                  <UserProfile {...props}
                    users={ this.props.users }
                    sessions={ this.props.sessions }
                    messages={ this.props.messages }
                    postResource={ this.props.postResource }
                    setActiveTab={ this.setActiveTab }
                    isTakingNotes={ this.props.isTakingNote }
                    flashMessage={ this.props.flashMessage }
                  />
                }
              />

              <Route
                path='/messages'
                render={ () =>
                  <Messages
									 	users={ this.props.users }
                    pageTitle={ getLabel('my_messages') }
                    backButton={ backButton }
                    getResource={ this.props.getResource }
                    updateResource={ this.updateResource }
                    messages={ this.props.messages }
                    setActiveTab= { this.setActiveTab }
                  />
                }
              />

              <Route
                path='/message/:id'
                render={ (props) =>
                  <Message {...props}
                    getResource={ this.props.getResource }
                    updateResource={ this.updateResource}
                    users={ this.props.users }
                    messages={ this.props.messages }
                    postResource={ this.props.postResource }
                    setActiveTab= { this.setActiveTab }
                  />
                }
              />
              <Route
                path='/agenda'
                render={ (props) =>
                  <Sessions {...props}
                    sessions={ this.props.sessions }
                    sponsors={ this.props.sponsors }
                    getResource={ this.props.getResource }
                    flashMessage={ this.props.flashMessage }
                    postResource={ this.props.postResource }
                    setActiveTab={ this.setActiveTab }
                    pageTitle={ this.getLabelizedNavTitle('agenda') }
                    currentEvent={ this.state.currentEvent }
                  />
                }
              />

              <Route
                path='/session/:id'
                render={ (props) =>
                  <Session {...props}
                    sessions={ this.props.sessions }
                    users={ this.props.users }
                    sponsors={ this.props.sponsors }
                    getResource={ this.props.getResource }
                    flashMessage={ this.props.flashMessage }
                    postResource={ this.props.postResource }
                    setActiveTab={ this.setActiveTab }
                    isTakingNotes={ this.props.isTakingNotes }
                    updateResource={ this.updateResource }
                  />
                }
              />

              <Route
                path='/evaluations'
                render={ (props) =>
                  <Evaluations {...props}
                    events={ this.props.events }
                    sessions={ this.props.sessions }
                    setActiveTab= { this.setActiveTab }
                    flashMessage={ this.props.flashMessage }
                    getResource={ this.props.getResource }
                  />
                }
              />

              <Route
                path='/event_evaluation/:id'
                render={ (props) =>
                  <EventEvaluation {...props}
                    getResource={ this.props.getResource }
                    events={ this.props.events }
                    loadSurveyFromEmail={ this.props.loadSurveyFromEmail }
                    setActiveTab= { this.setActiveTab }
                  />
                }
              />

              <Route
                path='/session_evaluation/:id?/:type?'
                render={ (props) =>
                  <SessionEvaluation {...props}
                    sessions={ this.props.sessions }
                    flashMessage={ this.props.flashMessage }
                    users={ this.props.users }
                    sponsors={ this.props.sponsors }
                    postResource={ this.props.postResource }
                    setActiveTab= { this.setActiveTab }
                  />
                }
              />

              <Route
                path='/one_on_one_session_evaluation/:id/one_on_one_meeting_id/:one_on_one_meeting_id'
                render={ (props) =>
                  <OneOnOneSessionEvaluation {...props}
                    sessions={ this.props.sessions }
                    flashMessage={ this.props.flashMessage }
                    users={ this.props.users }
                    sponsors={ this.props.sponsors }
                    postResource={ this.props.postResource }
                    setActiveTab= { this.setActiveTab }
                  />
                }
              />

              <Route
                path='/events'
                render={ (props) =>
                  <Events {...props}
                    events={ this.props.events }
                    changeEvent={ this.props.changeEvent }
                    getResource={ this.props.getResource }
                    setActiveTab= { this.setActiveTab }
                  />
                }
              />

              <Route
                path='/scanner'
                render={ (props) =>
                  <Scanner {...props}
                    users={ this.props.users }
                    getResource={ this.props.getResource }
                    postResource={ this.props.postResource }
                    setActiveTab= { this.setActiveTab }
                    flashMessage={ this.props.flashMessage }
                  />
                }
              />

              <Route
                path='/sponsors'
                render={ (props) =>
                  <Sponsors {...props}
                    sponsors={ this.props.sponsors }
                    getResource={ this.props.getResource }
                    setActiveTab= { this.setActiveTab }
                  />
                }
              />

              <Route
                path='/homepage'
                render={ (props) =>
                  <Homepage {...props}
                    pageTitle={ this.getLabelizedNavTitle('homepage') }
                    backButton={ backButton }
                    users={ this.props.users }
                    currentUser={ this.props.currentUser }
                    messages={ this.props.messages }
                    updateResource={ this.updateResource }
                    homepage={ this.props.homepage }
                    setActiveTab= { this.setActiveTab }
                    getResource={ this.props.getResource }
                  />
                }
              />

              <Route
                path='/sponsor/:id'
                render={ (props) =>
                  <Sponsor {...props}
                    sponsors={ this.props.sponsors }
                    flashMessage={ this.props.flashMessage }
                    users={ this.props.users }
                    postResource={ this.props.postResource }
                    setActiveTab={ this.setActiveTab }
                    isTakingNotes={ this.props.isTakingNotes }
                  />
                }
              />

              <Route
                path='/my_profile'
                render={ (props) =>
                  <MyProfile {...props}
                    users={ this.props.users }
                    sessions={ this.props.sessions }
                    messages={ this.props.messages }
                    updateResource={ this.updateResource }
                    postResource={ this.props.postResource }
                    flashMessage={ this.props.flashMessage }
                    logout={ this.props.logout }
                    currentUser={ this.props.currentUser }
                    setActiveTab= { this.setActiveTab }
                  />
                }
              />

              <Route
                path='/edit_profile'
                render={ (props) =>
                  <MyProfileEdit {...props}
                    users={ this.props.users }
                    postResource={ this.props.postResource }
                    flashMessage={ this.props.flashMessage }
                    currentUser={ this.props.currentUser }
                    setActiveTab= { this.setActiveTab }
                  />
                }
              />

              <Route
                path='/edit_photo'
                render={ (props) =>
                  <MyProfilePhoto {...props}
                    users={ this.props.users }
                    postResource={ this.props.postResource }
                    flashMessage={ this.props.flashMessage }
                    currentUser={ this.props.currentUser }
                    setActiveTab= { this.setActiveTab }
                  />
                }
              />

              <Route
                path='/leaderboard'
                render={ (props) =>
                  <Leaderboard {...props}
                    updateResource={ this.updateResource }
                    leaderboard={ this.props.leaderboard }
                    users={ this.props.users }
                    setActiveTab= { this.setActiveTab }
                  />
                }
              />

              <Route
                path='/custom_page/:id'
                render={ (props) =>
                  <CustomPage {...props}
                    currentUser={ this.props.currentUser }
                    homepage={ this.props.homepage }
                    setActiveTab= { this.setActiveTab }
                  />
                }
              />

              <Route
                path='/notes'
                render={ (props) =>
                  <Notes {...props}
                    sponsors={ this.props.sponsors }
                    backButton={ backButton }
                    updateResource={ this.updateResource }
                    users={ this.props.users }
                    sessions={ this.props.sessions }
                    setActiveTab= { this.setActiveTab }
                  />
                }
              />

              <Route
                path='/settings_and_support'
                render={ (props) =>
                  <SettingsAndSupport {...props}
                    postResource={ this.props.postResource }
                    refreshData={ this.props.refreshData }
                    currentUser={ this.props.currentUser }
                    users={ this.props.users }
                    backButton={ backButton }
                    setActiveTab= { this.setActiveTab }
                  />
                }
              />

              <Route
                path='/change_password'
                render={ (props) =>
                  <ResetPasswordForm {...props}
                    setPermanentPassword={ this.props.postResource }
                    setActiveTab= { this.setActiveTab }
                  />
                }
              />

              <Route
                path='/contact_form'
                render={ (props) =>
                  <ContactSupportForm {...props}
                    email={ currentEventUser.email }
                    setActiveTab= { this.setActiveTab }
                    emailRegEx={ /.?/ }
                    flashMessage={ this.props.flashMessage }
                    cancel={ () => props.history.push('/settings_and_support') }
                  />
                }
              />

              <Route
                path='/homepage_contact_form'
                render={ (props) =>
                  <ContactSupportForm {...props}
                    email={ currentEventUser.email }
                    setActiveTab= { this.setActiveTab }
                    emailRegEx={ /.?/ }
                    flashMessage={ this.props.flashMessage }
                    homepageBlock={ this.contactSupportBlock() }
                    cancel={ () => props.history.push('/homepage') }
                  />
                }
              />

              <Route path='/about' component={ ShowData }/>

              <Redirect to="/homepage" />

            </Switch>

          </div>
          {debug}
        </div>
      </BrowserRouter>
    )
  }
}

export default Layout
